"use client";

import React from "react";
import { Heart, Route, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const valuesData = [{
  title: "7+ Ani Experiență",
  description: "O decadă de precizie mecanică și pasiune pentru două roți, oferind soluții tehnice de top în Brașov.",
  icon: Route
}, {
  title: "1500+ Clienți",
  description: "Sute de motocicliști care ne-au încredințat siguranța lor și au plecat din service cu un zâmbet pe buze.",
  icon: Heart
}, {
  title: "Toate Mărcile",
  description: "Expertiză completă pentru orice model, de la japoneze la europene, folosind doar piese de calitate.",
  icon: ShieldCheck
}];
export default function OurCompassionateMission() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardsRef,
    isVisible: areCardsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223886" id="pasiune-și-experiență" className="dark bg-black text-foreground pt-16 pb-24 lg:pt-24 lg:pb-32 overflow-hidden relative border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {}
        <div ref={textRef} className={`mb-20 max-w-2xl transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-2xl font-default font-bold tracking-tighter uppercase text-white ![margin:0px_30px_24px_0px] md:text-5xl lg:text-6xl">
            Despre noi
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-sans max-w-xl leading-relaxed">
            La Pure Moto Performance, transformăm pasiunea pentru motociclism
            într-un standard de excelență tehnică. Situat în inima Brașovului,
            service-ul nostru este locul unde performanța întâlnește precizia,
            asigurându-ne că fiecare ieșire pe traseu este sigură și plină de
            adrenalină.
          </p>
        </div>

        {}
        <div ref={cardsRef} className={`grid grid-cols-1 md:grid-cols-3 gap-6 transition-all duration-1000 delay-200 ease-out ${areCardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {valuesData.map((value, i) => {
          const Icon = value.icon;
          return <Card key={i} data-index={i} className="bg-card border-none shadow-lg hover:shadow-primary/10 transition-shadow duration-300 rounded-xl">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4 text-primary">
                    <Icon size={24} strokeWidth={2} />
                  </div>
                  <CardTitle className="text-3xl font-default font-bold text-primary">
                    {value.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed font-default">
                    {value.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}